import { StatusPillVariant } from '../../../../shared/ui/status-pill/status-pill.component';
import { SummaryFinancialInvestmentModel } from './summary-financial-investment.model';
import { investmentPaymentLabel, investmentPaymentVariant } from '../../shared/investment-payment-status.util';
import { roundAmount } from '../../../../shared/round-amount';

export const FINANCIAL_PAY_METHODS = {
  cash: 'Efectivo',
  creditCard: 'Tarjeta de crédito',
  transfer: 'Transferencia bancaria',
  partner: 'Socio',
  creditPolicy: 'Póliza de crédito',
};

export const FINANCIAL_PAY_METHOD_OPTIONS: string[] = [
  FINANCIAL_PAY_METHODS.cash,
  FINANCIAL_PAY_METHODS.creditCard,
  FINANCIAL_PAY_METHODS.transfer,
  FINANCIAL_PAY_METHODS.partner,
  FINANCIAL_PAY_METHODS.creditPolicy,
];

export interface FinancialInvestmentRow extends SummaryFinancialInvestmentModel {
  __expanded?: boolean;
  __selected?: boolean;
}

export interface FinancialInvestmentDeposit {
  uid: string;
  investmentsFinancialId: string;
  paymentCardsUid: string;
  bankAccountsUid: string;
  amount: number;
  total: number;
  totalDeposit: number;
  depositDate: string | Date;
  date: string;
  typePay: string;
  concepto: string;
  commissions: number;
  bankAccountInfo: string;
  efectivoId: string | null;
  partnersId: number;
  polizaCreditoId: string | null;
  tableName: string;
  conciliationId: number | null;
}

export interface FinancialInvestmentRecord {
  uid: string;
  accountingModelsNumber: string;
  accountingModelsId: number;
  filesInvestmentUid: string;
  investmentValue: number;
  investmentDate: string | Date;
  investmentDescription: string;
  numberOfUnitsOrSharesInvested: number;
  percentageOfProfitabilityOrInterest: number;
  termInMonths: number;
  netBookValue: number;
  lastBalanceSheetDate: string | Date | null;
  generatesReturns: boolean;
  paided: string;
  isImage: boolean;
  isPdf: boolean;
  manualMovement: any;
}

export interface FinancialInvestmentRef {
  uid: string;
  investmentDescription?: string;
  investmentValue: number;
  accountNumber?: string;
}

export interface FinancialInvestmentPayDialogData {
  investment: FinancialInvestmentRef;
  editUid?: string;
}

export interface FinancialInvestmentFormDialogData {
  uid?: string;
}

export function roundMoney(value: number): number {
  return roundAmount(value);
}

export function paidVariant(row: SummaryFinancialInvestmentModel): StatusPillVariant {
  return investmentPaymentVariant(row ? { total: row.investmentValue, paid: row.paidAmount, pending: row.pendingAmount } : null);
}

export function paidLabel(row: SummaryFinancialInvestmentModel): string {
  return investmentPaymentLabel(row ? { total: row.investmentValue, paid: row.paidAmount, pending: row.pendingAmount, paidDate: row.lastPaymentDate } : null);
}

export function hasFile(row: { filesInvestmentUid?: string; isImage?: boolean; isPdf?: boolean }): boolean {
  return !!row && (row.isImage === true || row.isPdf === true);
}
